<template>
  <div
    class="tw:mb-2 tw:flex tw:cursor-pointer tw:gap-2 tw:rounded-sm tw:border tw:border-solid tw:border-blue-200 tw:bg-blue-100 tw:text-sm tw:text-blue-700 tw:hover:border-blue-300 tw:hover:bg-blue-200 tw:group"
    data-cy="selection"
    @click="emit('click')"
  >
    <div class="tw:flex-1 tw:py-3 tw:pl-4 tw:pr-2">
      <slot />
    </div>
    <div
      class="tw:items-center tw:pr-2"
      :class="{
        'tw:flex': isMobile,
        'tw:hidden tw:group-hover:flex': !isMobile,
      }"
    >
      {{ getLocaleText("global.view") }}
      <BaseIcon
        class="tw:text-lg"
        icon="angle-right"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import BaseIcon from "shared/components/base/BaseIcon";

const isMobile = inject("isMobile");

const emit = defineEmits(["click"]);
</script>
